export function lsGetItem(key, defaultValue = null) {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') return defaultValue;
  try {
    const value = window.localStorage.getItem(key);
    return value === null ? defaultValue : value;
  } catch (_) {
    return defaultValue;
  }
}

export function lsSetItem(key, value) {
  if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') return false;
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch (_) {
    return false;
  }
}
